import React, { FC, useEffect } from "react";
import { QuestionnaireType } from "@green0meter/api-client";

import { useCsobQuestionnaireStore } from "../../Questionnaires.store";
import Header from "./components/Header";
import { clientFormPlaceholder } from "./QuestionnairesTable.const";
import FormsTable from "./components/FormsTable";

import { useGetCsobFormsMetadata } from "@api";
import { Card, CardContent, Stack } from "@components/base";
import { useUserStore } from "@store/user";
import { Shake } from "@components/motion";

const QuestionnairesTable: FC = () => {
  const { user } = useUserStore();
  const { availableFormsMetadata } = useGetCsobFormsMetadata(user);
  const { setForms, shakeTableActive } = useCsobQuestionnaireStore();

  useEffect(() => {
    const formsMetadata = availableFormsMetadata ?? [];
    const clientFormExists = formsMetadata.some(
      (form) => form.questionnaireType === QuestionnaireType.Client,
    );
    const sortedForms = formsMetadata.slice().sort((a, b) => {
      if (
        a.questionnaireType === QuestionnaireType.Client &&
        b.questionnaireType !== QuestionnaireType.Client
      )
        return -1;
      if (
        a.questionnaireType !== QuestionnaireType.Client &&
        b.questionnaireType === QuestionnaireType.Client
      )
        return 1;

      return 0;
    });

    if (sortedForms?.length > 0 && !clientFormExists) {
      setForms([clientFormPlaceholder, ...sortedForms]);
    } else {
      setForms(sortedForms);
    }
  }, [availableFormsMetadata]);

  return (
    <Card>
      <CardContent>
        <Stack spacing={2}>
          <Header />
          <Shake active={shakeTableActive}>
            <FormsTable />
          </Shake>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default QuestionnairesTable;
